import { BREAKPOINT, ModalBasic } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const CustomizedModal = styled(ModalBasic)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: 12px;
  box-sizing: border-box;
  height: calc(100svh - 36px);
  outline: none;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 36px);
  padding: 0;
  overflow: hidden;
  max-height: 868px;
  max-width: 1024px;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    width: calc(100vw - 48px);
    height: calc(100svh - 36px);
    max-width: 720px;
  }

  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    width: 720px;
    height: calc(100svh - 36px);
  }

  @media screen and (min-width: ${BREAKPOINT.LG}px) {
    width: 1024px;
    height: 636px;
    min-height: 636px;
    max-width: 1024px;
  }
`
